import { createFileRoute } from "@tanstack/react-router"
import { friendsQueryOptions } from "@/entities/friend"
import { NewFriendsPage } from "@/pages/home"

export const Route = createFileRoute("/_authenticated/home/new")({
	loader: async ({ context }) => {
		const { userId } = context
		await context.queryClient.query({
			...friendsQueryOptions(userId),
			staleTime: "static",
		})
	},
	component: NewFriendsPage,
})
